"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _utils = require("composer-lib/lib/utils");

var _react = _interopRequireDefault(require("react"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _default = function _default(_ref) {
  var disabled = _ref.disabled,
      onClick = _ref.onClick,
      showRevisions = _ref.showRevisions;

  var clickHandler = function clickHandler(e) {
    (0, _utils.callIfPossible)(onClick, e);
    showRevisions();
  };

  return _react.default.createElement(_UIButton.default, {
    "data-test": "revisions-button",
    disabled: disabled,
    onClick: clickHandler,
    size: "small",
    use: "tertiary-light"
  }, _react.default.createElement(_UIIcon.default, {
    name: "bulletList"
  }));
};

exports.default = _default;
module.exports = exports.default;